import { PlanktonProductConfig } from './PlanktonProductConfig';

const prodCalkinsProductConfig: PlanktonProductConfig = {
  planktonVersionPrefix: 'onecms/:PRODUCT_ID',
  edsLtiRceToolId: '2ad55c2f-39e7-46fa-8c1f-f5035e473f73',
  edsLtiVideoToolId: '89eddab7-dbe8-45b6-ac5c-ead76128555f',
};

export default prodCalkinsProductConfig;
